import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Header from '../../common/Header';
import Footer from '../../common/Footer';
import SeoHelmet from '../../common/SeoHelmet';

const PriebeTheory = () => {
  return (
    <>
      <SeoHelmet
        title="GeoCalc | Priebe Vibro Replacement | Theory"
        description="Overview of the Priebe vibro replacement method for stone columns: improvement factors, depth effects, footing settlement charts, and the fictitious footing width bearing-capacity approximation."
        url="https://www.geocalc.app/priebe-theory"
        image="https://www.geocalc.app/assets/og-theory-v1.jpg"
        schemaType="page"
        breadcrumbs={[
          { name: 'Home', url: 'https://www.geocalc.app/' },
          { name: 'Priebe Vibro Replacement | Theory', url: 'https://www.geocalc.app/priebe-theory' },
        ]}
      />
      <Header />
      <div className="theory">
        <div className="theoryContainer">
          <h1>Priebe Vibro Replacement | Theory & Procedure</h1>
          <p>
            The Priebe method estimates the performance of vibro replacement by combining a basic improvement factor, a
            compressibility correction for the stone column, and a depth factor that reflects increasing confinement with depth.
          </p>
          <p>
            In practice, the workflow is built around the area ratio A/Ac, the column friction angle φc, the constrained modulus
            ratio Dc/Ds, and the treated depth-to-diameter ratio d/D. The original paper also provides chart-based reductions for
            single and strip footing settlements and a bearing-capacity approximation based on a fictitious footing width.
          </p>
          <p>
            This calculator follows the 1995 Ground Engineering paper by J. H. Priebe and reproduces the chart-driven parts as
            internal datasets/curves, while still plotting the selected result back on the corresponding chart for verification.
          </p>
          <div className="theoryButtonContainer">
            <Link to="/calculations/priebe">
              <Button variant="outlined" size="small">
                GO TO PRIEBE CALCULATOR
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PriebeTheory;
